<!--
  Vue file for the AI readiness check tool page.
  @author Yannik Sprengart, Adrian Rebmann, Andreas Emrich
-->

<template>
  <div class="kircWrapper" id="kirc">
    <!-- Particle bg -->
    <div class="particles"></div>

    <!-- Questions -->

    <div v-if="kirc" class="md-layout md-alignment-top-center">
      <div class="
          md-layout-item
          md-size-5
          md-medium-size-10
          md-small-size-100
          md-xsmall-size-100
        ">
        <!-- Back Button on Result Page -->
        <md-button v-if="showResult" @click="showResult = false" class="md-fab">
          <md-icon>arrow_back</md-icon>
        </md-button>
      </div>
      <div class="
          md-layout-item
          md-size-80
          md-medium-size-95
          md-small-size-95
          md-xsmall-size-100
        ">
        <!-- Question Area -->
        <md-card class="mainFormCard md-elevation-16" v-if="!showResult">
          <md-card-header>
            <div class="headlineWrapper">
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <div class="md-display-2 mainHeadline">
                    KI-Readiness-Check
                  </div>
                </div>
                <div align="right" class="md-layout-item md-size-50">
                  <md-button to="/readinesscheck/res" class="Secondary md-raised">
                    <span class="buttonText"> Ergebnis laden </span>
                  </md-button>
                </div>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <md-steppers id="kircStepper" md-vertical :md-active-step.sync="active">
              <div v-for="(item, catid) in kirc.categories" :key="item.name" :item="item" :index="catid">
                <!-- was  v-for="(item, key) in kirc.categories" :key="key" -->
                <md-step @click="scrollToTop()" :md-label="item.name" :id="item.name">
                  <!---<div>{{ item.name }}</div>-->
                  <div v-for="(question, index) in item.questions" :key="question.name">
                    <!-- TODO: Ask Kai about this prop -->
                    <div class="questionWrapper" v-if="!question.archived"> <!-- was v-if="!question.optional" -->


                      <div v-if="question.name == 'In welcher Branche ist Ihr Unternehmen tätig?'">
                        <h3 class="singleQuestion">
                          {{
                            (index + 1) + ". " +
                            question.name
                          }}
                        </h3>
                        <div id="largeDropdown" class="
                              md-layout-item
                              md-size-150
                              md-medium-size-120
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                              drop
                            ">
                          <!-- TODO:Remove after testing -->
                          <!-- <md-field>
                              <label>Antwort</label>
                              <md-select
                                v-model="
                                  kircinstance[key][index].answers[0].input
                                "
                                id="lots"
                              md-dense>
                                <md-option
                                  v-for="answer in question.answers"
                                  :key="answer.text"
                                  :value="answer.text"
                                  >{{ answer.text }}</md-option
                                >
                              </md-select>
                            </md-field> --><!-- [key[index]] -->
                          <md-field class="
                              md-layout-item
                              md-size-100
                              md-medium-size-100
                              md-small-size-100
                              md-xsmall-size-100
                            ">
                            <md-select v-model="kircinstance.categories[catid].questions[index].answers[0].input"
                              name="industry" id="industry" placeholder="Branche" md-dense
                              style="width: 100% !important; min-width: 100%;">
                              <md-option :value="key" v-for="key in industries" :key="key"
                                style="width: 100% !important; min-width: 100%;">{{ key }}</md-option>
                            </md-select>
                          </md-field>
                        </div>
                      </div>
                      <!-- Wo ist Ihr Unternehmen zu Hause -->
                      <!-- Location -->
                      <div v-else-if="
                        question.name ==
                        'Wie lautet die Postleitzahl Ihres Unternehmens?' ||
                        question.name == 'Wo ist ihr Unternehmen zu Hause?'
                      ">
                        <h3 class="singleQuestion">
                          {{
                            (index + 1) +
                            ". Wo ist Ihr Unternehmen zu Hause?"
                          }}
                        </h3>
                        <h5>Diese Angaben sind optional</h5>

                        <div class="md-layout md-gutter md-alignment-top-left">
                          <div class="
                              md-layout-item
                              md-size-50
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                            ">
                            <md-field>
                              <label>Ihre Postleitzahl:</label>
                              <md-input v-model="kircinstance.categories[catid].questions[index].answers[0].input
                                "></md-input>
                            </md-field>
                          </div>

                        </div>
                      </div>
                      <div
                        v-else-if="question.name == 'Bitte geben Sie Ihre E-Mail-Adresse an, wenn Sie die Ergebnisse des KI-Readiness-Checks zusätzlich per Mail erhalten möchten.'">
                        <h3 class="singleQuestion">
                          {{
                            (index + 1) +
                            ". " + question.name
                          }}
                        </h3>
                        <h5>Diese Angaben sind optional</h5>

                        <div class="md-layout md-gutter md-alignment-top-left">
                          <div class="
                              md-layout-item
                              md-size-50
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                            ">
                            <md-field>
                              <label>Ihre E-Mail-Adresse:</label>
                              <md-input v-model="kircinstance.categories[catid].questions[index].answers[0].input
                                "></md-input>
                            </md-field>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="question.name == 'In welchem der aufgeführten Bereiche, würden Sie sich gerne noch weiterbilden?'">
                        <h3 class="singleQuestion">
                          {{
                            (index + 1) +
                            ". " + question.name
                          }}
                        </h3>
                        <h5>Diese Angaben sind optional</h5>
                        <div class="md-layout md-gutter md-alignment-top-left">
                          <div class="
                              md-layout-item
                              md-size-20
                              md-medium-size-20
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                            " v-for="answer in question.answers">

                            <md-checkbox @change="deselectForFilterLabel(catid, index, answer.name, answer.text)"
                              v-model="kircinstance.categories[catid].questions[index].answers" :value="answer">{{
                                answer.text
                              }}</md-checkbox>
                          </div>
                        </div>
                        <!--
                        <div class="md-layout md-gutter md-alignment-top-left">
                          <div class="
                              md-layout-item
                              md-size-20
                              md-medium-size-20
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                            " v-for="x in filters">

                            <md-checkbox @change="deselectForFilterLabel(catid, index, x.filter, x.label)"
                              v-model="kircinstance.categories[catid].questions[index].answers[0].input"  :value="x.filter"
                              >{{ x.label
                              }}</md-checkbox>
                          </div>
                        </div>
                        -->
                      </div>
                      <!-- Alle Fragen ausser Standort -->
                      <div v-else>
                        <h3 class="singleQuestion">
                          {{ (index + 1) + ". " + question.name }}
                        </h3>
                        <!-- TODO check if deletion was ok
                        <h5 v-if="question.type == 'multiple'">
                          Mehrfachauswahl möglich
                        </h5>-->
                        <div class="md-layout md-gutter md-alignment-top-left">
                          <!-- Dropdown für lange Antworten -->
                          <div id="largeDropdown" v-if="question.answers.length > 11" class="
                              md-layout-item
                              md-size-60
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                              drop
                            ">
                            <!-- TODO:Remove after testing -->
                            <!-- <md-field>
                              <label>Antwort</label>
                              <md-select
                                v-model="
                                  kircinstance[key][index].answers[0].input
                                "
                                id="lots"
                              md-dense>
                                <md-option
                                  v-for="answer in question.answers"
                                  :key="answer.text"
                                  :value="answer.text"
                                  >{{ answer.text }}</md-option
                                >
                              </md-select>
                            </md-field> --><!-- [key[index]] -->
                            <!-- Introduced density to reduce list size-->
                            <v-select v-model="kircinstance.categories[catid].questions[index].answers[0].input
                              " :hint="Antwort" :items="question.answers" item-text="text" item-value="text"
                              label="Antwort" persistent-hint density="compact" width="100%" min-width="100%"
                              max-width="100%" single-line></v-select>
                          </div>
                          <!-- Normale Checkboxes -->
                          <div v-else class="
                              md-layout-item
                              md-size-20
                              md-medium-size-20
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                            " v-for="answer in question.answers" :key="answer.text">
                            <!-- Checkbox - Multiple DESELECT -->
                            <md-checkbox v-if="
                              (answer.name == 'keine Antwort möglich' ||
                                answer.name ==
                                'Keine der angegebenen Möglichkeiten.') &&
                              (question.type == 'multiple') // || question.type == 'single')
                            " @change="deselect(catid, index)"
                              v-model="kircinstance.categories[catid].questions[index].answers" :value="answer">{{
                                answer.name }}</md-checkbox>

                            <!-- Checkbox - Nicht Freitext + Multiple  -->
                            <md-checkbox v-else-if="
                              answer.name != 'Freitextantwort' &&
                              (question.type == 'multiple') // || question.type == 'single')
                            " @change="removeDeselect(catid, index)"
                              v-model="kircinstance.categories[catid].questions[index].answers" :value="answer">{{
                                answer.name }}</md-checkbox>

                            <!-- Checkbox - Nicht Freitext + Kein Multiple -->
                            <md-checkbox v-else-if="
                              answer.name != 'Freitextantwort' &&
                              (question.type == null || question.type == 'single')
                            " v-model="kircinstance.categories[catid].questions[index].answers[0]" :value="answer">{{
                              answer.text }}
                            </md-checkbox>


                            <!-- Freitext-Eingabe -->
                            <md-field v-else-if="
                              (question.type == 'free' ||
                                ((answer.name = 'Freitextantwort') &&
                                  (question.type == null))
                              ) && (kircinstance.categories[catid].questions[index].answers[0] != null)
                            " v-for="answerInstance in kircinstance.categories[catid].questions[index].answers"
                              :key="answerInstance.hash" v-show="answerInstance.name ==
                                'Sonstige*'
                                ">
                              <label>Antwort</label>
                              <md-input v-model="kircinstance.categories[catid].questions[index].answers[0].input
                                "></md-input>
                            </md-field>
                          </div><!-- div for checkboxes -->
                          <br />
                          <CircleTooltip v-if="question.help != null" :text="question.help" />
                        </div>
                      </div> <!-- end of v-else -->
                    </div> <!-- end of questionWrapper -->
                  </div> <!-- end of v-for -->
                  <!-- Button für letzten Schritt , this was abschließende Fragen, which is 4-->
                  <div v-if="catid == 4" class="confirmationWrapper">
                    <div>
                      <md-button class="md-accent md-raised nextBtn" @click="setDone(catid)">KIRC
                        Abschließen</md-button>
                    </div>
                    <md-switch v-model="forTesting">Dies ist ein Testlauf</md-switch>
                  </div>
                  <!-- Button für Steps -->
                  <div v-else class="confirmationWrapper">
                    <div>
                      <md-button class="md-accent md-raised nextBtn" @click="setDone(catid)">Weiter</md-button>
                    </div>
                  </div>
                </md-step>
              </div><!-- end of v-for -->
            </md-steppers>
            <div class="missedQuestions" v-if="
              error &&
              error !=
              'Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>'
            " v-html="error"></div>
            <!--md-button class="md-accent md-raised" @click="evaluate();">Auswerten</md-button-->
            <md-progress-bar v-if="showProgress" class="md-accent" md-mode="indeterminate"></md-progress-bar>
          </md-card-content>
        </md-card>

        <!-- Result Page -->

        <md-card v-if="showResult">
          <md-card-content>
            <div class="md-layout" :class="'md-alignment-top-left'">
              <div class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-left'">
                <div class="stickyHeading__Wrapper">
                  <div class="md-display-1 kiReadinessLevel__H1">
                    Ergebnisse
                  </div>
                  <md-divider></md-divider>
                </div>
              </div>
            </div>
            <SummaryCard title="Ihre Ergebnisübersicht" icon="mdi-scoreboard" v-if="showResult">
              <!-- Left Section -->
              <template #left>
                <TextCard>
                  <span slot="textCard__Icon">scoreboard</span>
                  <span slot="textCard__Headline">Ihr Reifegradlevel</span>
                  <div slot="textCard__Text">
                    <ResultCard :level="level" :resulttoken="resulttoken" :starclass="star" :size="60" />
                  </div>
                </TextCard>
              </template>
              <!-- Right Section -->
              <template #right>
                <TextCard>
                  <span slot="textCard__Icon">compare_arrows</span>
                  <!--span slot="textCard__Headline">Level {{(Math.round(finalscore/20))}}</span-->
                  <span slot="textCard__Headline">Vergleich zu anderen Unternehmen</span>
                  <div slot="textCard__Text">
                    <ChartJSRadar :labels="chartLabels" :datasets="chartDatasets" />
                    <Comparison :levelIndustry="levelIndustry" :levelSize="levelSize"
                      :amountCompaniesComparison="amountCompaniesComparison" />
                  </div>
                </TextCard>
              </template>
            </SummaryCard>
            <div class="md-layout" :class="'md-alignment-top-center'">
              <div class="md-layout-item md-size-80 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-center'">
                <div class="stickyHeading__Wrapper">
                  <div class="md-display-1 kiReadinessLevel__H1">
                    <span>Empfehlungen nach Reifegrad</span>
                  </div>
                  <md-divider></md-divider>
                </div>
                <md-card class="TextCard" v-for="(item, key) in rec" :key="key">
                  <md-card-header class="TextCard__Wrapper">
                    <md-card-header-text class="TextCard__Header">

                      <div class="md-title rectitle" style="display: flex;">
                        <div class="IconBox" style="margin-right: 40px;">
                          <md-icon class="IconBox__Icon" v-if="key === 'Leude'">
                            human
                          </md-icon>
                          <md-icon class="IconBox__Icon" v-if="key === 'Menschen'">
                            person
                          </md-icon>
                          <md-icon class="IconBox__Icon" v-else-if="key === 'Technologie'">
                            settings
                          </md-icon>
                          <md-icon class="IconBox__Icon" v-else-if="key === 'Umwelt'">
                            map
                          </md-icon>
                          <md-icon class="IconBox__Icon" v-else-if="key === 'Organisation'">
                            domain
                          </md-icon>
                          <md-icon class="IconBox__Icon" v-else>
                            home
                          </md-icon>
                        </div>
                        <h5>
                          {{ key }}
                        </h5>
                        <div class="stars-wrapper"
                          style="margin-left: 40px; width:100%; text-align: right; display: flex-end; justify-content: flex-end; float: right; clear: both;">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] >= 0.5">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] >= 1.5">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] >= 2.5">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] >= 3.5">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] >= 4.5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] < 1.5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] < 2.5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] < 3.5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] < 4.5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" width="15" height="15"
                            v-if="subLevels[key] < 0.5">
                          <v-btn class="collapse-button" icon="$chevron-down" @click="toggleCat(key)"
                            v-if="!isVisibleCat(key)">
                            <v-icon class="collapse-icon" color="#FFFFFF">mdi-chevron-down</v-icon>
                          </v-btn>
                          <v-btn class="collapse-button" icon="$chevron-up" @click="toggleCat(key)"
                            v-if="isVisibleCat(key)">
                            <v-icon class="collapse-icon" color="#FFFFFF">mdi-chevron-up</v-icon>
                          </v-btn>
                        </div>

                      </div>
                    </md-card-header-text>
                  </md-card-header>

                  <md-card-content class="TextCard__Content"
                    v-if="isVisibleCat(key)"><!-- TODO make this collapsible -->
                    <div v-for="(question, akey) in answerInstances"
                      v-if="(key === question.category) && (question.score > 0.1 && question.score < 5.2)" :key="akey">
                      <div class="md-layout md-gutter md-alignment-center-center">
                        <!-- this one is just a placeholder so the reifegrad stays centered. Wacky, i know, but it works :-P -->
                        <div style="visibility: hidden;">
                          <!-- <span>{{ question.answers[0].score }}/5</span> -->
                          <span>{{ question.score }}/5</span>
                        </div>
                        <div class="md-layout-item reifegrad">
                          <span>{{ question.maturityCriteria }}</span>
                        </div>
                        <div>
                          <span>{{ question.score }} / 5</span>
                        </div>
                      </div>
                      <div class="md-layout md-gutter md-alignment-top-center recommendation_container">
                        <div class="md-layout-item recommendation">
                          <span><span style="font-weight: bold;">Statusbericht: </span> {{ question.kircResText
                            }}</span>
                        </div>
                        <div class="md-layout-item recommendation">
                          <span><span style="font-weight: bold;">Empfehlung: </span> {{ question.rec }}</span>
                        </div>
                      </div>
                      <md-divider style="margin-top: 10px; margin-bottom: 10px"></md-divider>
                    </div>
                  </md-card-content>
                </md-card>
                <!-- Events available -->
                <RecCard v-if="recEvents.length > 0">
                  <span slot="recCard__Icon">calendar_today</span>
                  <span slot="recCard__Headline">Events</span>
                  <div slot="recCard__Content">
                    <md-table>
                      <md-table-row v-for="(recevent, index) in recEvents" :key="index.recevent">
                        <md-table-cell>{{ recevent.name }}</md-table-cell>
                        <md-table-cell>{{ recevent.eventdate }}</md-table-cell>
                        <md-table-cell>
                          <a :href="recevent.link" target="_blank">
                            <md-button class="md-accent eventBtn">
                              Mehr Dazu
                              <md-icon>arrow_right_alt</md-icon>
                            </md-button>
                          </a>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </RecCard>
                <!-- Events available -->
                <RecCard v-if="recEvents.length == 0">
                  <span slot="recCard__Icon">calendar_today</span>
                  <span slot="recCard__Headline">Events</span>
                  <div slot="recCard__Content">
                    Derzeit können wir für Ihr Ergebnis leider keine
                    Empfehlungen anzeigen
                  </div>
                </RecCard>
                <!-- Trainers available -->
                <RecCard v-if="recTrainer.length > 0">
                  <span slot="recCard__Icon">people</span>
                  <span slot="recCard__Headline">KI-Trainer</span>
                  <div slot="recCard__Content">
                    <md-table>
                      <md-table-row v-for="(rectrainer, index) in recTrainer" :key="index.rectrainer">
                        <router-link :to="'/trainerdetail/' + rectrainer.hash" target="_blank" class="no-link">
                          <md-table-cell class="ki-cell-small">{{
                            rectrainer.name
                            }}</md-table-cell>
                          <md-table-cell class="ki-cell-small">{{
                            rectrainer.competence_center
                            }}</md-table-cell>
                          <md-table-cell class="ki-cell-large">
                            <v-chip small chip class="ma-1" v-for="(
                                mainemphases, index
                              ) in rectrainer.main_emphases" :key="index.mainemphases">{{ mainemphases.name }}</v-chip>
                          </md-table-cell>
                        </router-link>
                      </md-table-row>
                    </md-table>
                  </div>
                </RecCard>
                <!-- Trainers NOT available -->
                <RecCard v-if="recTrainer.length == 0">
                  <span slot="recCard__Icon">people</span>
                  <span slot="recCard__Headline">KI-Trainer</span>
                  <div slot="recCard__Content">
                    Derzeit können wir für Ihr Ergebnis leider keine
                    Empfehlungen anzeigen
                  </div>
                </RecCard>
              </div>
            </div>
          </md-card-content>
          <md-card-actions class="resultAction-Wrapper">
            <md-button to="/readiness-welcome" v-if="!loggedIn"
              class="md-raised text-align-left md-primary CTA CTA--newCheck">
              <span class="buttonText">Neuer Check</span>
            </md-button>
            <!--
            <md-button
              :to="'/readinesscheck/' + resulttoken"
              v-if="!loggedIn"
              class="md-raised md-primary CTA CTA--signup"
            >
              <span class="buttonText">Jetzt Anmelden</span>
            </md-button>
            -->
          </md-card-actions>
        </md-card>
        <!-- END Result Page -->
      </div>
      <div class="
          md-layout-item
          md-size-5
          md-medium-size-10
          md-small-size-100
          md-xsmall-size-100
        "></div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="
        md-layout-item
        md-size-5
        md-medium-size-10
        md-small-size-100
        md-xsmall-size-100
      "></div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
  </div>
</template>

<script>
import json from "../../../../static/data.json";
import industries from "./data/industries.json";
import filter from "./data/filters.json";
import TextCard from "./components/TextCard.vue";
import RecCard from "./components/RecommendationCard.vue";
import ScoreCard from "./components/ScoreCard.vue";
import CircleTooltip from "./components/CircleTooltip.vue";
//import KIRCRadar from "./components/KIRCRadar.vue";
//import FiveStarRater from "./components/FiveStarRater.vue";
import auth from "../../../auth";
import {
  postKIRCResult2,
  getKIRC2,
  getKIRCResult,
  saveResForUser,
} from "../../../api";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { email } from "vuelidate/lib/validators";
import ChartJSRadar from "./components/ChartJSRadar.vue";
import SummaryCard from "./components/SummaryCard.vue";
import ResultCard from "./components/ResultCard.vue";
import Comparison from "./components/Comparison.vue";
//import FiveStarScale from "./components/FiveStarScale.vue";

export default {
  name: "KIRC2",
  components: {
    TextCard,
    RecCard,
    ScoreCard,
    CircleTooltip,
    Loading,
    ChartJSRadar,
    SummaryCard,
    ResultCard,
    Comparison
  },
  data() {
    ///console.log("Returning data.");
    //console.log(JSON.stringify(filter.areas));
    return {
      loggedIn: auth.loggedIn(),
      places: json,
      bundesland: null,
      landkreis: null,
      zipcode: null,
      emailadd: null,
      keys: [],
      forTesting: false,
      error: null,
      industries: industries["industries"],
      rec: null,
      kirc: null,
      kircinstance: null,
      industry: null,
      finalscore: 0,
      showProgress: false,
      showResult: false,
      chartLabels: ["Gesamt", "Menschen", "Umwelt", "Organisation", "Technologie"],//["Gesamt", "Technologie", "Organisation", "Umwelt", "Menschen"],
      chartDatasets: [
        {
          label: "Ihr Unternehmen",
          data: [0.0, 0.0, 0.0, 0.0, 0.0]
        },
        /*
        {
          label: "Unternehmen Ihrer Branche",
          data: [0.0, 0.0, 0.0, 0.0, 0.0]
        },
        {
          label: "Unternehmen Ihrer Größe",
          data: [0.0, 0.0, 0.0, 0.0, 0.0]
        }
          */
      ],
      active: null,
      filters: filter.areas,
      level1: {
        name: "Novize",
        text: "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst.",
      },
      level2: {
        name: "Erkunder",
        text: "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert.",
      },
      level3: {
        name: "Entdecker",
        text: "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt.",
      },
      level4: {
        name: "Vorbereiter",
        text: "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt.",
      },
      level5: {
        name: "Anwender",
        text: "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert.",
      },
      recEvents: [],
      recTrainer: [],
      recScores: null,
      level: -1,
      subLevels: null,
      kircResText: "",
      resulttoken: null,
      levelIndustry: 0,
      levelSize: 0,
      amountCompaniesComparison: 0,
      catVisibilities: {
        "Technologie": true,
        "Organisation": false,
        "Umwelt": false,
        "Menschen": false,
      }
    };
  },

  updated() {
    //This is a good place for debugging.
    console.log("Updating the form.");
  },
  created() {
    this.isLoading = true;
    console.log("Loading the form.");
    getKIRC2().then((res) => {
      if (!res) { // == null) {
        console.log("Error loading KIRC2. No response data there.");
        return;
      }
      this.analyzeQuestions("KIRC Questionnaire after receiving from the server", res);
      var r = JSON.stringify(res, null, 2); //, null, 2);
      //console.log("Result: " + r);

      var hackHashAreas = "de7f8d43-2177-4980-91b8-692980c0c205";

      this.kirc = res; //JSON.parse(r); //new Object();
      //reportKIRC();

      //console.log(this.kirc);
      this.analyzeQuestions("KIRC Questionnaire after parsing", this.kirc);
      /*
      this.kirc["Anwendungsbereiche und Technologien"] = res[
        "Anwendungsbereiche und Technologien"
      ].sort((a, b) => (a.index > b.index ? 1 : -1));
      this.kirc["Prozesse, Strategie und Organisation"] = res[
        "Prozesse, Strategie und Organisation"
      ].sort((a, b) => (a.index > b.index ? 1 : -1));
      this.kirc["Mitarbeiter"] = res["Mitarbeiter"].sort((a, b) =>
        a.index > b.index ? 1 : -1
      );
      this.kirc["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"] =
        res["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"].sort(
          (a, b) => (a.index > b.index ? 1 : -1)
        );
      this.kirc["Abschließende Fragen"] = res["Abschließende Fragen"].sort(
        (a, b) => (a.index > b.index ? 1 : -1)
      );
      */

      this.kirc.categories[4].questions[4].answers = this.buildAnswersForFilters();
      let deepClone = JSON.parse(JSON.stringify(this.kirc));
      this.analyzeQuestions("KIRC Questionnaire after cloning for instance", deepClone);
      /*
      for (let prop in this.kirc) {
        for (let i = 0; i < this.kirc[prop].length; i++) {
          //For question with follow-up questions.
          if (this.kirc[prop][i].followup.includes("#")) {
            let parts = this.kirc[prop][i].followup.split("#");
            this.kirc[prop][i].followindices = [];
            for (let x = 0; x < parts.length; x++) {
              if (parts[x].length > 0) {
                this.kirc[prop][i].followindices.push(parts[x]);
                this.kirc[prop][parts[x] - 1].optional = true;
              }
            }
          }
        }
      }

      for (let prop in this.kirc) {
        let j = 0;
        for (let i = 0; i < this.kirc[prop].length; i++) {
          if (!this.kirc[prop][i].optional) {
            j++;
            this.kirc[prop][i].newidx = j;
          }

          //Sort the answers according to the index.
          this.kirc[prop][i].answers = this.kirc[prop][i].answers.sort((a, b) =>
            a.index > b.index ? 1 : -1
          );
        }
      }
      */
      // Set kircinstance to sorted Kirc

      this.filterAnswers = [];
      this.kircinstance = deepClone;
      let num_categories = this.kircinstance.categories.length;
      for (let j = 0; j < num_categories; j++) {//let prop in this.kircinstance.categories) {
        this.keys.push(j);
        //console.log("Processing categories: " + num_categories);
        let questions = this.kircinstance.categories[j].questions;
        let num_questions = questions.length;
        for (let i = 0; i < num_questions; i++) {
          //console.log("Found " + num_questions + " questions in category " + j);
          if (questions[i].answers.length > 11) { //j was j everywhere
            //console.log("Encountered too many answers for " + j + " " + i + " Truncating to one answer");
            questions[i].answers = [
              questions[i].answers[0],
            ];
          } else if (questions[i].answers.length === 1) {
            //console.log("Encountered single answer result for " + j + " " + i);
            //console.log(this.kircinstance[prop][i].answers);
          } else if (questions[i].type == "multiple" && questions[i].name == "In welchem der aufgeführten Bereiche, würden Sie sich gerne noch weiterbilden?") {
            //var newAnswers = this.buildAnswersForFilters();
            //console.log("new answers: " + JSON.stringify(newAnswers));
            //questions[i].answers = newAnswers;
            //var globAnswers = this.kircinstance.categories[j].questions[i].answers;
            //console.log("glob answers: " + JSON.stringify(globAnswers));
            this.kircinstance.categories[j].questions[i].answers = []; //structuredClone(newAnswers); 
            /*questions[i].answers = [
              questions[i].answers[0],
            ];
            */
          } else if (questions[i].type == "multiple") {
            //console.log("Encountered multiple choice question for " + j + " " + i);
            questions[i].answers = [];
          } else {
            //console.log("Default case for " + j + " " + i + " Setting to empty map");
            questions[i].answers = [{}];
          }
        }
      }
      this.logAreaMultipleChoice();
      this.keys[0] = "Technologie";
      this.keys[1] = "Organisation";
      this.keys[2] = "Umwelt";
      this.keys[3] = "Menschen";
      this.keys[4] = "abschließende Fragen";
      this.active = this.keys[0];
      this.zipcode = "";
      this.emailadd = "";
      this.isLoading = false;
      console.log("Now we are done with loading.");
      //console.log("KIRC Instance: " + this.kircinstance);
      //console.log("KIRC:" + this.kirc)
    });
    console.log("Loaded the form.")
  },
  methods: {
    analyzeQuestions(label, k) {
      console.log("REPORT " + label);
      let cat_array = [];
      let cat_question_counts = [];
      let no_answer_counts = 0;
      for (let cat_id = 0; cat_id < k.categories.length; cat_id++) {
        let cat = k.categories[cat_id];
        cat_array.push(cat.name);
        let questions = cat.questions;
        let num_questions = questions.length;
        cat_question_counts.push(num_questions);
        for (let q_id = 0; q_id < cat.questions.length; q_id++) {
          let q = cat.questions[q_id];
          let answer_count = q.answers.length;
          if (answer_count == 0) {
            no_answer_counts++;
            console.log("Very bad: No answers for category " + cat_id + " and question " + q_id);
          }
        }
      }
      console.log("Categories: " + cat_array);
      console.log("Question Counts: " + cat_question_counts);
      console.log("No Answer Counts: " + no_answer_counts);
    },
    removeFromArray(array, item) {
      const index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
      }
      return array;
    },
    toggleCat(cat) {
      this.catVisibilities[cat] = !this.catVisibilities[cat];
    },
    isVisibleCat(cat) {
      return this.catVisibilities[cat];
    },
    logAreaMultipleChoice() {
      /*
      questions[i].type == "multiple" && questions[i].name=="In welchem der aufgeführten Bereiche, würden Sie sich gerne noch weiterbilden?") {
            //var newAnswers = this.buildAnswersForFilters();
      */
      let question = this.kircinstance.categories[4].questions[4];
      if (question.type == "multiple" &&
        question.name == "In welchem der aufgeführten Bereiche, würden Sie sich gerne noch weiterbilden?") {
        console.log("Your choices for area:");
        let answers = question.answers;
        console.log(JSON.stringify(answers, null, 2));
      } else {
        console.log("Check your references for 'area' question, as the indexes might be broken.");
      }
    },
    buildAnswersForFilters() {
      //TODO first we need the explicit mappings as in
      var answers = [];
      for (var index = 0; index < this.filters.length; index++) {
        var x = this.filters[index];
        console.log("Found filter: " + JSON.stringify(x));
        var filter = x["filter"];
        var label = x.label;
        var newAnswer = {
          "uuid": null,
          "id": null,
          "externalId": "KIRCAnswer0",
          "metaData": null,
          "timestamp": null,
          "description": "",
          "name": filter,
          "hash": "", //TODO check if that works
          "clz": "",
          "text": label,
          "input": "",
          "score": -1,
          "rec": null,
          "index": index,
          "causesfollowup": false,
          "kircResText": null,
          "tags": []
        };
        answers.push(newAnswer);
      }
      return answers;
    },
    //Method for removing deselect

    removeDeselect(key, index) {
      console.log("Calling removeDeselect");
      for (var i = 0; i < this.kircinstance.categories[key].questions[index].answers.length; i++) {
        if (
          this.kircinstance.categories[key].questions[index].answers[i].text !=
          "Keine der angegebenen Möglichkeiten." &&
          this.kircinstance.categories[key].questions[index].answers[i].text !=
          "keine Antwort möglich"
        ) {
          const newArr = this.kircinstance.categories[key].questions[index].answers.filter(
            (item) =>
              item.text !== "Keine der angegebenen Möglichkeiten." &&
              item.text !== "keine Antwort möglich"
          );
          console.log("removeDeselect: New Array: " + newArr);
          this.kircinstance.categories[key].questions[index].answers.length = 0;
          this.kircinstance.categories[key].questions[index].answers.push.apply(
            this.kircinstance.categories[key].questions[index].answers,
            newArr
          ); // Append new contents
          break;
        }
      }
      console.log("Exiting removeDeselect");
    },
    // Method for deselecting on a multiple choice checkbox
    deselectForFilterLabel(key, index, filter, label) {
      console.log("Calling deselectFilters");
      if (this.filterAnswers == null || this.filterAnswers.length == 0 || (this.filterAnswers.indexOf(filter) == -1)) {
        this.filterAnswers.push(filter);
      } else if (this.filterAnswers.indexOf(filter) != -1) {
        this.filterAnswers = this.removeFromArray(this.filterAnswers, filter);
      } else {
        console.log("What happened here? Show me the filter: " + filter);
      }
      this.kircinstance.categories[key].questions[index].answers[0].input = this.filterAnswers.join(',');
      console.log("Currently selected filters: " + this.kircinstance.categories[key].questions[index].answers[0].input);
      console.log("Exiting deselectFilters");
    },
    // Method for deselecting on a multiple choice checkbox
    deselect(key, index) {
      console.log("Calling deselect");
      for (var i = 0; i < this.kircinstance.categories[key].questions[index].answers.length; i++) {
        if (
          this.kircinstance.categories[key].questions[index].answers[i].text ==
          "Keine der angegebenen Möglichkeiten." ||
          this.kircinstance.categories[key].questions[index].answers[i].text ==
          "keine Antwort möglich"
        ) {
          const newArr = this.kircinstance.categories[key].questions[index].answers.filter(
            (item) =>
              item.text === "Keine der angegebenen Möglichkeiten." ||
              item.text === "keine Antwort möglich"
          );

          this.kircinstance.categories[key].questions[index].answers.length = 0;
          this.kircinstance.categories[key].questions[index].answers.push.apply(
            this.kircinstance.categories[key].questions[index].answers,
            newArr
          ); // Append new contents
          break;
        }
      }
      console.log("Exiting deselect");
    },
    updateCharts() {
      console.log(this.subLevels);
      console.log(this.chartLabels);
      let yourData = [
        this.level,
        this.subLevels[this.chartLabels[1]],
        this.subLevels[this.chartLabels[2]],
        this.subLevels[this.chartLabels[3]],
        this.subLevels[this.chartLabels[4]]
      ];
      let industryData = new Array(5).fill(this.levelIndustry);
      let sizeData = new Array(5).fill(this.levelSize);
      //console.log("Before update:", JSON.stringify(this.chartDatasets));
      this.$nextTick(() => {
        this.chartDatasets = [
          {
            label: "Ihr Unternehmen",
            data: yourData
          },
          /*
          {
            label: "Unternehmen Ihrer Branche",
            data: industryData
          },
          {
            label: "Unternehmen Ihrer Größe",
            data: sizeData
          }
            */
        ];
      });
      //console.log("After update:", JSON.stringify(this.chartDatasets));
    },

    getNextKey(key) {
      console.log("Entering getNextKey");
      if (key < this.keys.length + -1) {
        return key + 1;
      }
      /*
      for (let i = 0; i < this.keys.length; i++) {
        if (this.keys[i] == key) {
          return this.keys[i + 1];
        }
      }
        */
      console.warn("There is no next key.")
      return null;
    },
    setDone(id) {
      console.log("Entering setDone");
      this[id] = true;
      let next = this.getNextKey(id);
      if (next) {
        this.active = this.keys[next];
        this.scrollToTop();
      } else {
        this.evaluate();
        return;
      }
      let catname = this.keys[next];
      console.log("Exiting setDone. Continuing with category " + next + " " + catname);
    },
    scrollToTop() {
      console.log("Entering scrollToTop");
      window.scrollTo(0, 0);
      console.log("Exiting scrollToTop");
    },
    checkPLZ() {
      console.log("Entering checkPLZ");
      this.zipcode = this.kircinstance.categories[4].questions[5].answers[0].input;
      if (!this.zipcode || this.zipcode.trim().length == 0) {
        return true; //because it is optional, it can be empty
      }
      console.log("For PLZ: " + this.zipcode); //TODO comment this out
      const postalCodePattern = /^[0-9]{5}$/;
      return postalCodePattern.test(this.zipcode);
    },
    checkEMail() {
      console.log("Entering checkEMail");
      this.emailadd = this.kircinstance.categories[4].questions[6].answers[0].input;
      if (!this.emailadd || this.emailadd.trim().length == 0) {
        return true; //because it is optional, it can be empty
      }
      console.log("for address:   " + this.emailadd); //TODO comment this out 
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(this.emailadd);
    },
    filterSeperators(text, sep, replace) {
      return text.replace(sep, replace);
    },
    /* sort answer instances by index */
    sortByIndex() {
      this.answerInstance = this.answerInstances.sort(function (a, b) {
        var x = a.index;
        var y = b.index;
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    },
    evaluate() {
      console.log("Entering evaluate");
      //hack: as optional is currently not correctly processed, we need to add it
      //this.kircinstance.categories[4].questions[6].optional = true; //email address is optional
      //this.kircinstance.categories[4].questions[5].optional = true; //PLZ is optional
      let s = "Sie haben die folgenden Fragen noch nicht beantwortet:<ul>";
      for (let key in this.kircinstance.categories) {
        //if (key !== 4) { //key !== "abschließende Fragen")
        for (let index in this.kircinstance.categories[key].questions) {
          if (key != 4) { //hack scores for all other questions
            this.kircinstance.categories[key].questions[index].answers[0].score = this.kircinstance.categories[key].questions[index].answers[0].score + 1;
          }
          if (
            !(
              //unnötig, existieren immer
              this.kircinstance.categories[key].questions[index].answers &&
              this.kircinstance.categories[key].questions[index].answers[0] &&
              this.kircinstance.categories[key].questions[index].answers[0].text
            )

            //!this.kirc.categories[key].questions[index].optional
          ) {
            if (key == 4 && (index == 5 || index == 6)) {
              //don't enforce mail and zipcode
              continue;
            }
            let dkey = this.keys[key];
            let dindex = Number(index) + 1;
            s +=
              "<li>" +
              dkey + ": Frage " + dindex +
              ": " +
              this.kircinstance.categories[key].questions[index].name +
              "</li>";
            console.log("Found an error: " + s);
          }
        }
      }
      //}
      if (!this.checkPLZ()) {
        s += "<li>Bitte geben Sie eine gültige Postleitzahl ein.</li>";
      }
      if (!this.checkEMail()) {
        s += "<li>Bitte geben Sie eine gültige E-Mail-Adresse ein.</li>";
      }
      s += "</ul>";
      this.error = s;
      if (
        s !== "Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>"
      ) {
        console.log("Validation failed. Errors should be displayed.");
        return;
      }
      //validation was successful
      console.log("Validation succeeded. Commencing with score calculation.");
      this.showProgress = true;
      let score = 0;
      let maxscore = 0;

      //hack for score calculation of "keine Antwort möglich
      for (let cat in this.kircinstance.categories) {
        for (let index in this.kircinstance.categories[cat].questions) {
          if (
            this.kircinstance.categories[cat].questions[index].answers[0] &&
            this.kircinstance.categories[cat].questions[index].answers[0].text ==
            "keine Antwort möglich"
          ) {
            this.kircinstance.categories[cat].questions[index].answers[0].score = 0;
          }
        }
      }

      //score calculation
      /*
      for (let key in this.kircinstance.categories) {
        for (let index in this.kircinstance.categories[key].questions) {
          maxscore += 5;
          if (
            this.kircinstance.categories[key].questions[index].followup &&
            this.kircinstance.categories[key].questions[index].followup === "matrix" &&
            this.kircinstance.categories[key].questions[index].answers[1]
          ) {
            //console.log(this.kircinstance.categories[key].questions[index].answers[1].text)
            this.kircinstance.categories[key].questions[index].answers[0].score =
              this.kircinstance.categories[key].questions[index].answers[1].score[
                this.kircinstance.categories[key].questions[index].answers[0].text.replace(/\s/g, "")
              ];
            this.kircinstance.categories[key].questions[index].answers[0].input =
              this.kircinstance.categories[key].questions[index].answers[1].text;
            this.kircinstance.categories[key].questions[index].answers.splice(1, 1);
          }
          if (
            this.kircinstance.categories[key].questions[index].answers[0] &&
            this.kircinstance.categories[key].questions[index].answers[0].text
          ) {
            score += this.kircinstance.categories[key].questions[index].answers[0].score;
            if (
              this.kircinstance.categories[key].questions[index].answers[0].text ==
              "keine Antwort möglich"
            ) {
              maxscore -= 5;
            }
          } else {
            this.kircinstance.categories[key].questions[index].answers = [];
            maxscore -= 5;
          }
        }
      }

      this.finalscore = (score * 100) / (27 * 5);
      console.log("Final Score: " + this.finalscore);
      */

      // For Testing
      if (this.forTesting) {
        this.kircinstance["test"] = true;
      }

      //TODO: Remove this
      console.log("Trying to send the result now.");
      console.log(JSON.stringify(this.kircinstance));
      postKIRCResult2(this.kircinstance)
        .then((res) => {
          // // TODO Comment Out log
          //console.log("KIRC RES");
          if (res) {
            ; //console.log(JSON.stringify(res));
          } else {
            console.error("No response from server for KIRC Result.");
          }
          let newrec = {};


          //console.log("after removal:");
          let recKeys = Object.keys(res.rec);
          for (var key of recKeys) {
            newrec[key] = res.rec[key].replace("_", "").replace("[sep]", "<br /> ");
            //newValue = res.rec[key].replace("[sep]", "<br /> ");
            if (newrec[key] == "") {
              delete newrec[key];
            }
          }
          //console.log(JSON.stringify(newrec))
          //console.log(newrec);

          this.recEvents = res.recevents;
          if (this.recEvents === ('undefined' || null)) {
            this.recEvents = [];
          }
          this.recTrainer = res.reckitrainers;
          if (this.recTrainer === ('undefined' || null)) {
            this.recTrainer = [];
          }
          this.rec = newrec;
          this.finalscore = res.score;
          this.resulttoken = res.hash;
          this.isLoading = false;
          this.kircResText = res.kircResText;
          this.showResult = true;

          this.level = res.level;
          this.subLevels = res.sublevels;
          this.subScores = res.subscoresPerLevel;
          this.levelIndustry = res.avgPerIndustry; //TODO make a call for this
          this.levelSize = res.avgPerSize; //TODO make a call for this
          this.amountCompaniesComparison = res.numKIRCs; //TODO make a call for this
          this.answerInstances = res.answerInstances;
          this.sortByIndex();
          //console.log("Received the following answer instances from backend: " + JSON.stringify(this.answerInstances));
          //TODO remove hacks
          if (this.levelIndustry === ('undefined' || null)) {
            this.levelIndustry = 3;
          }
          if (this.levelSize === ('undefined' || null)) {
            this.levelSize = 3;
          }
          if (this.amountCompaniesComparison === ('undefined' || null)) {
            this.amountCompaniesComparison = 0;
          }
          this.scoreIndustry = this.levelIndustry;
          this.scoreSize = this.levelSize;
          this.levelIndustry = parseFloat(this.scoreIndustry / 168.1 * 5.0).toFixed(2);
          this.levelSize = parseFloat(this.scoreSize / 168.1 * 5.0).toFixed(2);
          this.updateCharts();
          this.scrollToTop();
          if (this.loggedIn) {
            //saveResForUser(this.resulttoken)
          }
        })
        .catch(() => {
          window.setTimeout(() => {
            this.showProgress = false;
            this.showResult = true;
            this.scrollToTop();
          }, 3000);
        });
      console.log("Exiting evaluate");
    },
  },
};
/**
 *  RL 1:	 0-20%
 *  RL 2:   21-40%
 *  RL 3:   41-60%
 *  RL 4:   61-80%
 *  RL 5:   81-100%
 */
</script>


<style>
/* TODO: Adjust this */
/* Global Styles */
/* Dropdown Menu Wrapper */
.md-menu-content {
  min-height: auto;
  min-width: 400px;
  /* max-width: 300px; */
  max-height: 50vh;
}

.md-checkbox .md-checkbox-label {
  height: 100% !important;
}
</style>


<style scoped>
/* Local Styles */
.kircWrapper {
  margin-top: -20px;
  margin-bottom: -100px;
  padding: 4em 4em 8em 4em;
  min-height: 1000px;
}

.md-steppers.md-vertical .md-stepper-content {
  padding: 0px !important;
}

.particles {
  text-align: center;
  color: #2c3e50;
  background-image: url("../../../assets/particle-bg-min.png");
  background-color: #641b1a;
  box-sizing: border-box;
  background-repeat: repeat;
  background-size: auto;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answerBoxes {
  padding-bottom: 2em;
  padding-right: 12px;
}

.kiReadinessLevel__H1 {
  text-align: center;
  color: #333;
  font-weight: bold;
}

.kiReadinessLevel__H1.left-align {
  text-align: left !important;
}

.CustomCard {
  border-radius: 15px;
  margin: 18px;
  padding: 0px 18px;
  box-shadow: 0 0.6px 2.2px rgba(0, 0, 0, 0.014),
    0 1.3px 5.3px rgba(0, 0, 0, 0.02), 0 2.5px 10px rgba(0, 0, 0, 0.025),
    0 4.5px 17.9px rgba(0, 0, 0, 0.03), 0 8.4px 33.4px rgba(0, 0, 0, 0.036),
    0 20px 80px rgba(0, 0, 0, 0.05);

  display: flex;
  justify-content: center;
  align-items: center;
}

.progessWrapper {
  position: relative;
}

.finalScoreWrapper {
  position: relative;
  text-align: center;
}

.finalScoreWrapper p {
  text-align: justify;
}

.mainFormCard {
  max-width: 1300px;
  margin: 0 auto;
  /* padding: 16px; */
}

.questionWrapper {
  background-color: #f1f3f6;
  padding: 2em;
  margin-bottom: 2em;
  border-radius: 6px;
}

.singleQuestion {
  margin: 0px 0px 1em 0px;
}

/* Make the md-select dropdown scrollable */
.md-menu-content {
  max-height: 200px !important;
  /* Limit dropdown height */
  overflow-y: auto !important;
  /* Enable vertical scrolling */
}

.md-menu {
  max-height: 200px !important;
  /* Limit dropdown height */
  overflow-y: auto !important;
  /* Enable vertical scrolling */
}

.headlineWrapper {
  background-color: #1a1a1a;
  padding: 1em;
  margin: -16px -16px 16px -16px;
}

.mainHeadline {
  color: #fff;
  font-size: 34px;
  line-height: 40px;
}

.subHeading {
  font-weight: 500;
}

.nextBtn {
  margin-top: 24px;
}

.missedQuestions {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  background-color: #eb8f8f;
  margin: 18px;
  padding: 18px;
  line-height: 1.6em;
  border-radius: 10px;
}

.missedQuestions ul li {
  color: green;
}

.CTA {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 36px 18px 18px 18px;
  height: 60px;
  width: 180px;
  border-radius: 10px;
  text-transform: none;
}

.CTA.Secondary {
  color: #9a9da8;
}

.Secondary--LoggedIn {
  color: #9a9da8;
}

.Secondary--LoggedIn:hover {
  margin-left: -50px;
  color: #000000;
  background-color: rgba(240, 248, 255, 0);
}

.stickyHeading__Wrapper {
  width: 100%;
  position: sticky;
  top: 0;
  padding: 12px 16px;
  z-index: 333;
  background-color: #fff;
  display: flex;
}

.resultAction-Wrapper {
  padding-right: 30px;
  padding-bottom: 12px;
}

.ki-cell-small {
  width: 25% !important;
}

.ki-cell-large {
  width: 50% !important;
}

.no-link {
  text-decoration: none !important;
  color: black !important;
}

.confirmationWrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.reifegrad {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-weight: bold;
}

div#largeDropdown *,
div#largeDropdown * v-option {
  width: 100%;
  color: #FFFF88;
}

.collapse-button {
  display: flex-end;
  align-items: center;
  background-color: #641b1a;
  margin-left: 20px;
  color: #FFFFFF;
}

.collapse-icon {
  color: #FFFFFF;
}

.rectitle {
  width: 100%;
  display: flex;
}

/* copied from other */
.IconBox {
  height: 45px;
  width: 45px;
  min-height: 45px;
  min-width: 45px;
  border-radius: 15px;
  background-color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  box-shadow: 0 0.6px 2.2px rgba(0, 0, 0, 0.014),
    0 1.3px 5.3px rgba(0, 0, 0, 0.02), 0 2.5px 10px rgba(0, 0, 0, 0.025),
    0 4.5px 17.9px rgba(0, 0, 0, 0.03), 0 8.4px 33.4px rgba(0, 0, 0, 0.036),
    0 20px 80px rgba(0, 0, 0, 0.05);
}

.IconBox__Icon {
  margin-right: 10.5px;
  color: #fff !important;
}

.TextCard__Content {
  font-size: 16px;
  line-height: 160%;
}

.TextCard {
  border-radius: 15px;
  margin: 18px;
  padding: 0px 18px;
}

.TextCard__Header {
  display: flex;
  align-items: center;
}

/* Responsive */
@media (max-width: 1120px) {
  .kircWrapper {
    margin-top: -20px;
    margin-bottom: -100px;
    padding: 3em 1em 6em 1em;
    min-height: 1000px;
  }
}

@media (max-width: 600px) {
  .answerBoxes {
    padding-bottom: 0em;
  }

  .kircWrapper {
    margin-top: -20px;
    margin-bottom: -100px;
    padding: 0em 0em 3em 0em;
    min-height: 1000px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company/kirc/KIRC2.vue